import { useSelector } from 'react-redux';
import { useCartQuantity } from '@client/cart/hooks/cartQuantity/useCartQuantity';
import { CartQuantityItem } from '@client/cart/redux/cartQuantity/redux';
import { AppState } from '@client/common/redux/store';
import { useUserData } from '@client/context/hooks';
import { ProductBulkPriceType } from 'b2b-common/core/product/api/ProductBulkPrices.types';
import { selectProductBySku } from '../redux/products/full/redux';

interface UseProductBulkPricesReturnType {
  bulkPrices: ProductBulkPriceType[];
  bestMatchIndex: number;
  currentQuantity: number;
  cartQuantityItem: CartQuantityItem;
}

export const getCurrentPriceIndex = (
  bulkPrices: any,
  currentQuantity: number,
): number => {
  let bestMatchIndex = -1;

  if (!Array.isArray(bulkPrices)) {
    return bestMatchIndex;
  }

  if (currentQuantity > 0 && bulkPrices.length > 0) {
    for (let i = bulkPrices.length - 1; i >= 0; i--) {
      if (bulkPrices[i].minQuantity <= currentQuantity) {
        bestMatchIndex = i;
        break;
      }
    }
  }

  return bestMatchIndex;
};

export const useProductBulkPrices = (sku: string): UseProductBulkPricesReturnType => {
  const { items } = useCartQuantity();
  const { isLoggedIn } = useUserData();
  const productData = useSelector(
    (state: AppState) => selectProductBySku(state, sku),
  );
  const bulkPrices = isLoggedIn ? Object.values(productData.data?.bulkPrices || {}) : [];
  const currentQuantity = items[sku]?.quantity || 0;
  const bestMatchIndex = getCurrentPriceIndex(bulkPrices, currentQuantity);

  return {
    bulkPrices,
    bestMatchIndex,
    currentQuantity,
    cartQuantityItem: items[sku],
  };
};
